import styled from 'styled-components';

import {Button} from 'components/ui-kit/Button';
import {breakpoint} from 'theme';

export const ControlsWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;

    @media (min-width: ${breakpoint.phone}) {
        justify-content: flex-start;
        width: 100%;
    }
`;

export const CreateButton = styled(Button)`
    @media (min-width: ${breakpoint.phone}) {
        max-width: fit-content;
    }
`;
export const RecallButton = styled(Button)`
    margin-left: auto;
    @media (min-width: ${breakpoint.phone}) {
        margin-left: auto;
        max-width: fit-content;
    }
`;
